<template>
    <el-dialog :title="title" :visible.sync="dialogVisible" :width="width" @close="reset">
        <p>
        <el-input v-model="query" :placeholder="placeholder" size="small" @input="refresh" ref="input"
            @keyup.up.native="keyUp" @keyup.down.native="keyDown" @keyup.enter.native="keyEnter">
             <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        </p>
        <el-table v-loading="loading" :data="tableData" ref="tb" highlight-current-row>
            <el-table-column width="50">
                <template slot-scope="scope">
                    <el-button type="text" @click="selClick(scope.row)">选择</el-button>
                </template>
            </el-table-column>
            <el-table-column v-for="(col, index) in columns" :key="index"
            :prop="col.prop" :label="col.label"></el-table-column>
        </el-table>
    </el-dialog>
</template>

<script>
export default {
    data: function(){
        return {
            query: '',
            tableData: [],
            dialogVisible: false,
            currentRowIdx: -1,
            loading:false
        }
    },
    props: {
        title: {
            type: String,
            default: '请选择'
        },
        url: String,
        placeholder: String,
        extraParam: Object,
        searchKey: {
            type: String,
            default: 'numberOrName'
        },
        width: {
            type: String,
            default: '30%'
        },
        columns: {
            type: Array,
            default: []
        },
        okText: {
            type: String,
            default: '确认'
        }
    },
    methods: {
        selClick: function(row){
            this.$emit('ok', row);
            this.hide();
        },
        reset: function(){
            this.query = '';
            this.tableData = [];
            this.currentRowIdx = -1;
            this.$refs.tb.setCurrentRow(null);
        },
        show: function(){
            this.dialogVisible = true;
            setTimeout(() => {
                this.$refs.input.focus();
            }, 0);
            this.refresh();
        },
        hide: function(){
            this.dialogVisible = false;
        },
        keyUp:function(){
            if(!this.tableData.length) return;

            var idx = this.currentRowIdx-1;
            this.currentRowIdx = Math.max(idx, 0);
            this.$refs.tb.setCurrentRow(this.tableData[this.currentRowIdx]);
        },
        keyDown:function(){
            if(!this.tableData.length) return;

            var idx = this.currentRowIdx+1;
            this.currentRowIdx = Math.min(idx, this.tableData.length-1);
            this.$refs.tb.setCurrentRow(this.tableData[this.currentRowIdx]);
        },
        keyEnter: function(){
            if(!this.tableData.length) return;

            if(this.currentRowIdx == -1){
                if(this.tableData.length == 1){
                    this.selClick(this.tableData[0]);
                }
            }
            else{
                this.selClick(this.tableData[this.currentRowIdx]);
            }
        },
        refresh: function(){
            var postData = { }
            postData[this.searchKey] = this.query
            Object.assign(postData, this.extraParam)

            this.loading = true;
            this.$httpPost(this.url, postData).then(res => {
                if (!res.isSuccess) {
                    this.$message.error(res.message)
                }
                var items = res.datalist || [];
                this.tableData = items;
            }).finally(()=>{
                this.loading = false;
            })
        }
    },
    mounted: function(){
    }
}
</script>

<style>

</style>